import { create } from 'zustand'

export const useStore = create((set) => ({
  data: {},
  setData: (data) => set(() => ({ data })),
  formData: {},
  setFormData: (formData) => set(() => ({ formData })),
  engaged: false,
  setEngaged: (engaged) => set(() => ({ engaged })),
  product: 'CW',
  setProduct: (product) => set(() => ({ product })),
  config: {},
  setConfig: (config) => set(() => ({ config })),
}))
